<template>
  <div class="header">
    <!-- <div class="header-logo"><img src="../../assets/logo.png"></div> -->
    <!-- <div class="header-left">
      <span>齐心集团B2B业务管理系统BMS</span>
    </div> -->
    <div class="header-right">
      <a href="javascript:;" class="task-btn" :class="{'task-zindex': isTaskShow}" @click="showExportListFlag = true"><i class="icon el-icon-s-tools"></i>任务管理</a>
	  <transition name="el-fade-in">
		<div class="task-mask" v-if="isTaskShow"></div>
	  </transition>
	  <transition name="el-fade-in">
		<div class="task-tip" v-if="isTaskShow">增加新功能啦</div>
	  </transition>
      <el-dropdown @command="handleCommand">
        <div class="el-dropdown-link user-icon"><img src="../../assets/header_user.png"
               width="26"
               height="26"></div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>{{rolidName}}</el-dropdown-item>
          <el-dropdown-item v-if="rolidId==65">{{company}}</el-dropdown-item>
          <el-dropdown-item command="ChangePassword">修改密码</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span class="user-name">{{name}}{{nickName}}</span><a href="javascript:;"
         @click="logout"
         style="color:#005BF5;">退出登录</a>
    </div>
    <el-dialog title="修改密码"
               center
               :visible.sync="addDepositoryFlag"
               top="10vh"
               width="600px"
               @closed="handlerResetFields">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-position="right"
               label-width="110px">
        <el-form-item label="原密码:"
                      prop="oldPassword">
          <el-input type="password"
                    v-model="ruleForm.oldPassword"
                    autocomplete="off"
                    placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码:"
                      prop="password">
          <el-input type="password"
                    v-model="ruleForm.password"
                    autocomplete="off"
                    placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码:"
                      prop="checkPass">
          <el-input type="password"
                    v-model="ruleForm.checkPass"
                    autocomplete="off"
                    placeholder="请再次输入新密码"></el-input>
        </el-form-item>
        <el-form-item class="children-item-h-center">
          <el-button @click="addDepositoryFlag=false">取　消</el-button>
          <el-button type="primary"
                     @click="submitForm('ruleForm')"
                     style="margin-left:20px;">确　定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
	<el-dialog title="导出/导入" :visible.sync="showExportListFlag" width="1400px">
		<exportListDetail v-if="showExportListFlag"></exportListDetail>
	</el-dialog>
  </div>
</template>
<script>
import { Encrypt } from '@/common/AESUtils.js'
import exportListDetail from "./exportList.vue";
import { watermarkUtils } from '@/common/watermark';
import util from '@/common/util';
export default {
  name: "top",
  components: { exportListDetail },
  data () {
    var checkOldPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.password !== '') {
          this.$refs.ruleForm.validateField('password');
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else if (!reg.test(value)) {
        callback(new Error('至少8-16个字符，至少1个大写字母，1个小写字母和1个数字!'));
      } else if (value === this.ruleForm.oldPassword) {
        callback(new Error('新密码不能与原密码一致!'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      showExportListFlag: false,
	  isTaskShow: false,
      name: sessionStorage.getItem("UNAME"),
      nickName: sessionStorage.getItem("NICKNAME"),
      rolidName: sessionStorage.getItem("ROLENAME"),
      rolidId: sessionStorage.getItem("ROLEID"),
      company: sessionStorage.getItem("PLATFORMNAME"),
      addDepositoryFlag: false,
      ruleForm: {
        oldPassword: '',
        password: '',
        checkPass: ''
      },
      rules: {
        oldPassword: [
          { validator: checkOldPass, trigger: 'blur' }
        ],
        password: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
      this.getTaskInfo();
      this.setWatermark();
  },
  destroyed() {
      watermarkUtils.destroy();
  },
  computed: {
  },
  methods: {
    handleCommand (command) {
      switch (command) {
        case 'ChangePassword':
          this.addDepositoryFlag = true;
          break;
      }
    },
    logout () {
      sessionStorage.clear();
      this.$store.commit('add_tabs', []);
      this.$router.replace({
        path: '/login',
        // query: {redirect: this.$router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
      })
    },
    async updatePwd () {
      let res = await this.$api.updatePwd({
        password: Encrypt(this.ruleForm.password.trim()).toString(),
        oldPassword: Encrypt(this.ruleForm.oldPassword.trim()).toString()
      })
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '修改成功'
        })
        this.addDepositoryFlag = false;
        this.handlerResetFields();
      }
    },
    handlerResetFields () {
      this.$refs['ruleForm'].resetFields();
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updatePwd();
        } else {
          return false;
        }
      });
    },
	// 查询任务管理遮罩是否提示
	getTaskInfo(){
		const flag = localStorage.getItem('taskMaskFlag');
		if(flag != 1){
			this.isTaskShow = true;
			localStorage.setItem('taskMaskFlag', 1);
			setTimeout(()=>{
				this.isTaskShow = false;
			}, 5000);
		}
	},
    // 设置水印
    setWatermark() {
        let userInfo = sessionStorage.getItem('userInfo');
        if(userInfo) {
            userInfo = JSON.parse(userInfo);
            let watermarkText = userInfo.nickName;
            if(userInfo.userType == '02') {
                if(userInfo.oneDepartment){
                    watermarkText += '@' + userInfo.oneDepartment;
                }
            }else if(userInfo.mobile) {
                watermarkText += '@' + userInfo.mobile.slice(-4);
            }
            watermarkText += '<br>' + util.formatDate(new Date().getTime(), '', 1);
            watermarkUtils.init({
                text: watermarkText,
            });
        }else{
            setTimeout(() => {
                this.setWatermark();
            }, 500);
        }
    },
  }
}
</script>
<style lang="less" scoped>
.header {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #fff;
  box-shadow: 0px 3px 17px 1px rgba(102, 102, 102, 0.08);
}
.header-logo {
  line-height: 1;
  float: left;
  margin: 11px 0 0 26px;
}
.header-logo img {
  height: 28px;
  vertical-align: top;
}
.header-left {
  height: 28px;
  line-height: 28px;
  float: left;
  margin: 11px 0 0 12px;
  font-size: 18px;
  color: #005BF5;
}
.header-right {
  float: right;
  padding-right: 20px;
  font-size: 14px;
  color: #666;
}
.task-btn {
	display: inline-block;
	height: 46px;
	line-height: 46px;
	padding: 0 15px;
	margin-right: 5px;
	border-radius: 50px;
	background-color: #fff;
	color: #3B3A3A;
	&.task-zindex {
		position: relative;
		z-index: 10000;
	}
	.icon {
		margin-right: 5px;
		font-size: 18px;
		color: #005BF5;
		vertical-align: middle;
		margin-top: -2px;
	}
}
.task-mask {
	background: rgba(0, 0, 0, 0.34);
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 9999;
}
.task-tip {
	display: inline-block;
	height: 36px;
	line-height: 36px;
	border-radius: 36px;
	background-color: #4390F7;
	padding: 0 16px;
	color: #fff;
	position: absolute;
	top: 78px;
	margin-left: -45px;
	z-index: 10001;
	&::before {
		content: '';
		display: block;
		width: 18px;
		height: 36px;
		background: url(../../assets/header_task_tip.png) no-repeat;
		position: absolute;
		left: -8px;
		top: -32px;
	}
	&::after {
		content: '';
		display: block;
		width: 500px;
		height: 150px;
		position: absolute;
		top: -78px;
		right: 0;
	}
}
.el-dropdown-link {
  cursor: pointer;
}
.user-icon {
  margin-right: 8px;
}
.user-icon img {
  vertical-align: top;
  margin-top: 12px;
}
.user-name {
  margin-right: 12px;
}
</style>